import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const OrderLinesSection = "/reports/omi/order-lines";

export const OrderLinesListPath = OrderLinesSection;

export enum OrderLinesListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo"
}

export enum OrderLinesListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand"
}

export type OrderLinesListUrlDialog = "download" | TabActionDialog;
export type orderLinesListUrlFilters = Filters<OrderLinesListUrlFiltersEnum> &
  FiltersWithMultipleValues<OrderLinesListUrlFiltersWithMultipleValues>;

export type OrderLinesUrlQueryParams = ActiveTab &
  orderLinesListUrlFilters &
  BulkAction &
  Dialog<OrderLinesListUrlDialog> &
  Pagination &
  SingleAction;

export const orderLinesListUrl = (params?: OrderLinesUrlQueryParams) =>
  OrderLinesListPath + "?" + stringifyQs(params);
